import { useState } from "react";
import { C, Input, Select } from "./ui";

const PROVIDERS = [
  { id:1,  nombre:"BROU Agro",          cat:"Financiamiento", localidad:"Montevideo",   desc:"Créditos rurales, seguros y servicios bancarios especializados para el sector agropecuario uruguayo.", tel:"0800 2020",       web:"www.brou.com.uy" },
  { id:2,  nombre:"Zoetis Uruguay",      cat:"Veterinaria",    localidad:"Montevideo",   desc:"Vacunas, antiparasitarios y soluciones sanitarias para ganadería bovina y ovina de ciclo completo.", tel:"+598 2628 5800",   web:"www.zoetis.com.uy" },
  { id:3,  nombre:"ADP Semillas",        cat:"Semillas",       localidad:"Canelones",    desc:"Semillas forrajeras certificadas para praderas permanentes y cultivos de cobertura en Uruguay.", tel:"+598 2908 0066",  web:"www.adpsemillas.com.uy" },
  { id:4,  nombre:"John Deere Uruguay",  cat:"Maquinaria",     localidad:"Soriano",      desc:"Tractores, cosechadoras y equipos para la mecanización y eficiencia operativa del campo.", tel:"+598 2900 0000",  web:"www.deere.com.uy" },
  { id:5,  nombre:"Syngenta Uruguay",    cat:"Agroquímicos",   localidad:"Montevideo",   desc:"Herbicidas, fungicidas e insecticidas para la protección de cultivos en rotaciones ganaderas.", tel:"+598 2628 7700",  web:"www.syngenta.com.uy" },
  { id:6,  nombre:"Mapfre Seguros Agro", cat:"Seguros",        localidad:"Montevideo",   desc:"Seguro pecuario, seguro de pasturas y coberturas para infraestructura rural y maquinaria.", tel:"0800 3678",        web:"www.mapfre.com.uy" },
  { id:7,  nombre:"Corteva Uruguay",     cat:"Agroquímicos",   localidad:"Paysandú",     desc:"Nutrición vegetal, semillas Pioneer y protección de cultivos para mayor productividad por hectárea.", tel:"+598 2628 9200",  web:"www.corteva.com.uy" },
  { id:8,  nombre:"BioVet Uruguay",      cat:"Veterinaria",    localidad:"Salto",        desc:"Medicamentos veterinarios, vitaminas y suplementos minerales para rodeos bovinos y ovinos.", tel:"+598 2908 4400",  web:"www.biovet.com.uy" },
  { id:9,  nombre:"Banco Itaú Agro",     cat:"Financiamiento", localidad:"Montevideo",   desc:"Financiamiento de capital de trabajo, compra de animales y equipamiento para productores rurales.", tel:"0800 4828",        web:"www.itau.com.uy" },
  { id:10, nombre:"Urufarma",            cat:"Veterinaria",    localidad:"Canelones",    desc:"Distribución de medicamentos veterinarios, productos sanitarios y equipamiento de campo.", tel:"+598 2924 2626",  web:"www.urufarma.com.uy" },
  { id:11, nombre:"Yolanda Semillas",    cat:"Semillas",       localidad:"Soriano",      desc:"Semillas forrajeras, granos y mezclas pratenses especialmente adaptadas para el sur de Uruguay.", tel:"+598 2308 5555",  web:"www.semillasyolanda.com.uy" },
  { id:12, nombre:"BSE Agro",            cat:"Seguros",        localidad:"Montevideo",   desc:"Banco de Seguros del Estado — seguros de vida rural, granizo, incendio y cobertura pecuaria.", tel:"*BSE (273)",       web:"www.bse.com.uy" },
  { id:13, nombre:"Agrositio",           cat:"Semillas",       localidad:"Artigas",      desc:"Venta de semillas, insumos y equipamiento especializado para la zona norte del país.", tel:"+598 4732 5000",  web:"www.agrositio.com.uy" },
];

const CAT_COLORS = {
  "Financiamiento": { bg:"#D0E4F4", tx:"#1E5080", ic:"💳" },
  "Veterinaria":    { bg:"#D4E8D4", tx:"#2D6E3A", ic:"🩺" },
  "Semillas":       { bg:"#FFF0C0", tx:"#7A5800", ic:"🌱" },
  "Maquinaria":     { bg:"#FAE0D0", tx:"#7A3020", ic:"🚜" },
  "Agroquímicos":   { bg:"#F0E4FA", tx:"#5A2080", ic:"🧪" },
  "Seguros":        { bg:"#E4EEF8", tx:"#2A4A6A", ic:"🛡" },
};

const CATEGORIAS = [...new Set(PROVIDERS.map(p=>p.cat))];

const LOCALIDADES = ["Todas", ...new Set(PROVIDERS.map(p=>p.localidad))].sort();

export function MarketplacePanel() {
  const [filtroCat, setFiltroCat] = useState("Todas");
  const [filtroLoc, setFiltroLoc] = useState("Todas");
  const [busqueda, setBusqueda] = useState("");

  let filtrados = PROVIDERS;
  if (filtroCat!=="Todas") filtrados = filtrados.filter(p=>p.cat===filtroCat);
  if (filtroLoc!=="Todas") filtrados = filtrados.filter(p=>p.localidad===filtroLoc);
  if (busqueda) {
    const q = busqueda.toLowerCase();
    filtrados = filtrados.filter(p=>
      p.nombre.toLowerCase().includes(q) ||
      p.desc.toLowerCase().includes(q) ||
      p.cat.toLowerCase().includes(q)
    );
  }

  return (
    <div style={{ flex:1, overflowY:"auto", background:C.fondo }}>
      <div style={{ padding:"20px 24px" }}>
        <div style={{ marginBottom:20 }}>
          <div style={{ fontFamily:"serif", fontSize:22, color:C.tierra, fontWeight:600, marginBottom:4 }}>Proveedores y Servicios</div>
          <div style={{ fontSize:13, color:C.muted }}>Directorio de empresas del sector agropecuario uruguayo</div>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:12, marginBottom:16 }}>
          <Input label="Buscar proveedor o producto" value={busqueda} onChange={setBusqueda} placeholder="Semillas, vacunas, maquinaria..."/>
          <Select label="Localidad" value={filtroLoc} onChange={setFiltroLoc} options={LOCALIDADES}/>
        </div>

        <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:16 }}>
          {["Todas",...CATEGORIAS].map(cat=>{
            const style = CAT_COLORS[cat];
            return (
              <button key={cat} onClick={()=>setFiltroCat(cat)} style={{
                padding:"5px 12px", fontSize:11, fontFamily:"monospace", border:"none", cursor:"pointer",
                borderRadius:16, transition:"all 0.15s",
                background: filtroCat===cat ? (style?.bg||C.pasto) : C.arena,
                color:       filtroCat===cat ? (style?.tx||"white") : C.muted,
                fontWeight:  filtroCat===cat ? 600 : 400,
              }}>{cat}</button>
            );
          })}
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(300px, 1fr))", gap:14 }}>
          {filtrados.map(p=>{
            const c = CAT_COLORS[p.cat]||{ bg:C.arena, tx:C.muted, ic:"🏢" };
            return (
              <div key={p.id} style={{ background:C.white, borderRadius:12, padding:"16px 18px",
                border:`1.5px solid ${C.arenaDark}`, display:"flex", flexDirection:"column", gap:10 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div style={{ fontFamily:"serif", fontSize:16, fontWeight:600, color:C.tierra }}>{p.nombre}</div>
                  <span style={{ fontSize:10, fontFamily:"monospace", padding:"3px 8px", borderRadius:12,
                    background:c.bg, color:c.tx, whiteSpace:"nowrap" }}>
                    {c.ic} {p.cat}
                  </span>
                </div>
                <div style={{ fontSize:12, color:C.muted, lineHeight:1.6 }}>{p.desc}</div>
                <div style={{ display:"flex", gap:8, marginTop:"auto", paddingTop:4, borderTop:`1px solid ${C.arenaDark}`, flexWrap:"wrap" }}>
                  <a href={`tel:${p.tel.replace(/\s/g,"")}`} style={{ fontSize:11, color:C.pasto, textDecoration:"none", fontFamily:"monospace" }}>
                    📞 {p.tel}
                  </a>
                  <a href={`https://${p.web}`} target="_blank" rel="noreferrer"
                    style={{ fontSize:11, color:C.pastoLight, textDecoration:"none", marginLeft:"auto" }}>
                    🌐 {p.web}
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ textAlign:"center", marginTop:28, padding:"14px 20px",
          background:C.arena, borderRadius:10, fontSize:12, color:C.muted }}>
          ¿Tu empresa quiere aparecer aquí? · contacto@campoia.uy
        </div>
      </div>
    </div>
  );
}
